import type { ChartTheme } from './index';

export const lightTheme: ChartTheme = {
  background: '#ffffff',
  gridColor: 'rgba(0, 0, 0, 0.06)',
  axisTextColor: '#787b86',
  axisBorderColor: '#e0e3eb',
  crosshairColor: '#9598a1',
  tooltipBackground: '#ffffff',
  tooltipBorder: '#e0e3eb',
  tooltipText: '#131722',
  candleUpColor: '#26a69a',
  candleDownColor: '#ef5350',
  candleUpBorderColor: '#26a69a',
  candleDownBorderColor: '#ef5350',
  textColor: '#131722',
  textSecondary: '#787b86',
};
